module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "primo",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn fast",
      "leave-active-class": "animated fadeOut fast",
      "mode": "out-in"
    }
  }, [(this.authenticated) ? _c('router-view') : _c('div', {
    staticClass: "horizontal-align-ab"
  }, [(_vm.loadingMsg === null) ? _c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_vm._v(_vm._s(_vm.loadingMsg))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd37a80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 224
// module chunks = 0